"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_http_1 = require("@comunica/bus-http");

require("isomorphic-fetch");

var parseLink = require("parse-link-header");
/**
 * A comunica Memento Http Actor.
 */


var ActorHttpMemento =
/*#__PURE__*/
function (_bus_http_1$ActorHttp) {
  _inherits(ActorHttpMemento, _bus_http_1$ActorHttp);

  function ActorHttpMemento(args) {
    _classCallCheck(this, ActorHttpMemento);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorHttpMemento).call(this, args));
  }

  _createClass(ActorHttpMemento, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (action.context && action.context.has(exports.KEY_CONTEXT_DATETIME) && action.context.get(exports.KEY_CONTEXT_DATETIME) instanceof Date) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor only handles request with a set valid datetime.');

              case 2:
                if (!(action.init && new Headers(action.init.headers || {}).has('accept-datetime'))) {
                  _context.next = 4;
                  break;
                }

                throw new Error('The request already has a set datetime.');

              case 4:
                return _context.abrupt("return", true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var init, headers, httpAction, result, links, followLink;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Duplicate the ActionHttp to append a datetime header to the request.
                init = action.init ? Object.assign({}, action.init) : {};
                headers = init.headers = new Headers(init.headers || {});

                if (action.context && action.context.has(exports.KEY_CONTEXT_DATETIME)) {
                  headers.append('accept-datetime', action.context.get(exports.KEY_CONTEXT_DATETIME).toUTCString());
                }

                httpAction = {
                  context: action.context,
                  input: action.input,
                  init: init
                }; // Execute the request and follow the timegate in the response (if any).

                _context2.next = 6;
                return this.mediatorHttp.mediate(httpAction);

              case 6:
                result = _context2.sent;

                if (!(headers.has('accept-datetime') && result.headers && !result.headers.has('memento-datetime'))) {
                  _context2.next = 13;
                  break;
                }

                // The links might have a timegate that can help us
                links = result.headers.has('link') && parseLink(result.headers.get('link'));

                if (!(links && links.timegate)) {
                  _context2.next = 13;
                  break;
                }

                result.body.cancel(); // Respond with a time-negotiated response from the timegate instead

                followLink = {
                  context: action.context,
                  input: links.timegate.url,
                  init: init
                };
                return _context2.abrupt("return", this.mediatorHttp.mediate(followLink));

              case 13:
                return _context2.abrupt("return", result);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorHttpMemento;
}(bus_http_1.ActorHttp);

exports.ActorHttpMemento = ActorHttpMemento;
/**
 * @type {string} Context entry for the desired datetime.
 */

exports.KEY_CONTEXT_DATETIME = '@comunica/actor-http-memento:datetime';